<template>
  <el-form
    :class="$style.declaration"
    :model="form"
    :rules="rules"
    ref="ruleForm"
    :show-message="false">
    <div :class="$style.content">
      <div :class="$style.topImg" @click="top">
        <img
          src="@/assets/top.png"
          alt=""
          v-show="isTop"
          @mouseleave="mouseLeaves"
          @mouseover="mouseOvers"/>
        <img src="@/assets/top1.png" alt="" v-show="!isTop"/>
      </div>
      <common-title>
        {{ $t('common.PartI') }}
        <span>*{{ $t('common.required') }}</span>
      </common-title>
      <div :class="$style.typeRadio">
        <span v-if="$store.getters.language === 'cn'">
          <span :class="$style.red">*</span>
          {{ $t('common.Pleaseselectenteringorleaving') }}：</span>
        <el-form-item style="margin: 0 0 0 23px;">
          <el-radio
            :class="$style.commonRadio"
            v-model="form.entryExitType"
            @click.native.prevent="handleClick('0',1)"
            label="0">{{ $t('common.Immigration') }}</el-radio>
          <el-radio
            :class="$style.commonRadio"
            v-model="form.entryExitType"
            @click.native.prevent="handleClick('1',1)"
            label="1">{{ $t('common.Exit') }}</el-radio>
        </el-form-item>
      </div>
      <table
        cellpadding="0"
        cellspacing="0"
        :class="$style.table">
        <tr align="center">
          <td><span :class="$style.red">*</span>{{ form.entryExitType === '1'? $t('common.ExitTo') : $t('common.EntryFrom') }}</td>
          <td colspan="8" style="padding: 5px; border-right: none;">
            <el-form-item style="margin: 0;" prop="entryExit">
              <el-input :class="$style.input" v-model="form.entryExit" :placeholder="$t('common.placeholder')"/>
              <!-- <el-select
                v-model="form.entryExit"
                filterable
                allow-create
                :class="$style.input"
                default-first-option
                :placeholder="$t('common.Pleaseselect')">
                <el-option
                  v-for="item in options"
                  :key="item"
                  :label="item"
                  :value="item"/>
              </el-select> -->
            </el-form-item>
          </td>
        </tr>
        <tr align="center">
          <td><span :class="$style.red">*</span>{{ $t('common.Name') }}</td>
          <td colspan="2" style="padding: 5px;">
            <el-form-item style="margin: 0;" prop="name">
              <el-input :class="$style.input" v-model="form.name" :placeholder="$t('common.placeholder')"/>
            </el-form-item>
          </td>
          <td><span :class="$style.red">*</span>{{ $t('common.Gender') }}</td>
          <td colspan="2">
            <el-form-item style="margin: 0 0 0 16px; text-align: left;" prop="gender">
              <el-radio
                :class="$style.commonRadio"
                v-model="form.gender"
                @click.native.prevent="handleClick('0',2)"
                label="0">{{ $t('common.M') }}</el-radio>
              <el-radio
                :class="$style.commonRadio"
                v-model="form.gender"
                @click.native.prevent="handleClick('1',2)"
                label="1">{{ $t('common.F') }}</el-radio>
            </el-form-item>
          </td>
          <td><span :class="$style.red">*</span>{{ $t('common.Nationality') }}</td>
          <td colspan="2" style="padding: 5px; border-right: none;">
            <el-form-item style="margin: 0;" prop="nationality">
              <el-select
                v-model="form.nationality"
                :class="$style.input"
                filterable
                :placeholder="$t('common.Pleaseselect')">
                <el-option
                  v-for="i in countyList"
                  :label="i.name"
                  :value="i.code"
                  :key="i.code"/>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr align="center">
          <td><span :class="$style.red">*</span>{{ $t('common.PlaceofBirth') }}</td>
          <td colspan="2" style="padding: 5px;">
            <el-form-item style="margin: 0;" prop="birthplace">
              <el-input :class="$style.input" v-model="form.birthplace" :placeholder="$t('common.placeholder')"/>
            </el-form-item>
          </td>
          <td><span :class="$style.red">*</span>{{ $t('common.DateofBrith') }}</td>
          <td colspan="2" style="padding: 5px;">
            <el-form-item style="margin: 0;" prop="birthTime">
              <el-date-picker
                size="large"
                v-model="form.birthTime"
                :class="[$style.datePicker,$style.input]"
                :default-value="new Date('1980-01-01')"
                type="date"
                format="yyyy - MM - dd"
                :placeholder="$t('common.YearMonthDay')"/>
            </el-form-item>
          </td>
          <td><span :class="$style.red">*</span>{{ $t('common.TravelDocumentType') }} </td>
          <td colspan="2" style="padding: 5px; border-right: none;">
            <el-form-item style="margin: 0;" prop="documentType">
              <el-select
                size="large"
                :placeholder="$t('common.Pleaseselect')"
                v-model="form.documentType"
                filterable
                :class="$style.input">
                <el-option
                  v-for="item in documentList"
                  :label="item.name"
                  :value="item.code"
                  :key="item.code"/>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr align="center">
          <td><span :class="$style.red">*</span>{{ $t('common.TravelDocumentNumber') }}</td>
          <td colspan="2" style="padding: 5px;">
            <el-form-item style="margin: 0;" prop="documentNum">
              <el-input :class="$style.input" v-model="form.documentNum" :placeholder="$t('common.placeholder')"/>
            </el-form-item>
          </td>
          <td><span :class="$style.red">*</span>{{ $t('common.PlaceofIssue') }}</td>
          <td colspan="2" style="padding: 5px;">
            <el-form-item style="margin: 0;" prop="issue">
              <el-input :class="$style.input" v-model="form.issue" :placeholder="$t('common.placeholder')"/>
            </el-form-item>
          </td>
          <td><span :class="$style.red">*</span>{{ $t('common.Contactnumber') }}</td>
          <td colspan="2" style="padding: 5px; border-right: none;">
            <div style="display: flex; ">
              <el-form-item
                style="margin: 0;"
                :class="$style.phoneInputHeader"
                prop="phoneTitle">
                <el-input
                  maxlength="4"
                  :placeholder=" $t('common.Code')"
                  :class="$style.input"
                  @input="(value)=>handleNumber(value,1)"
                  v-model="phoneTitle">
                  <template #prefix>
                    +
                  </template>
                </el-input>
              </el-form-item>
              <span :class="$style.phoneInputCenter">-</span>
              <el-form-item
                style="margin: 0;"
                :class="$style.phoneInput"
                prop="phone">
                <el-input
                  :class="$style.input"
                  :placeholder=" $t('common.Pleaseenteryourcontactnumber')"
                  @input="(value)=>handleNumber(value,2)"
                  v-model="form.phone"/>
              </el-form-item>
            </div>
          </td>
        </tr>
        <tr align="center">
          <td colspan="1" style="border-bottom: none;">
            <span :class="$style.red">*</span>{{ $t('common.Permanentresidenceaddress') }}</td>
          <td colspan="7" align="left" style="padding: 5px; border-bottom: none; border-right: none;">
            <el-form-item style="margin: 0;" prop="address">
              <el-input
                maxlength="200"
                :class="$style.input"
                v-model="form.address"
                :placeholder="$t('common.placeholder')"/>
            </el-form-item>
          </td>
        </tr>
      </table>
      <common-title style="margin-top: 20px;">
        {{ $t('common.PartII') }}
        <b>{{ $t('common.details') }}</b>
      </common-title>
      <!-- border="1px;" -->
      <table
        v-for="(item,index) in form.list"
        :key="`${index} + ${item.cashType}`"
        cellpadding="0"
        cellspacing="0"
        :style="item['active']"
        @mouseover="mouseOver(index)"
        @mouseleave="mouseLeave(index)"
        :class="$style.table">
        <tr v-if="$store.getters.language === 'cn'">
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 13%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <!-- <th style="width: 10%; height: 0; border: none;"/> -->
        </tr>
        <tr>
          <!-- border-bottom: none;" -->

          <td
            rowspan="5"
            align="center"
            class="td"
            style="border-bottom: none;"
            :style="{'width': ((languageTypeData === 'pr'|| languageTypeData === 'us')? '66px' : '')}">
            {{ $t('common.item' + (index + 1)) }}
          </td>
          <td colspan="8" style="border-right: none;">
            <el-form-item style="margin: 0 0 0 15px;">
              <el-radio
                :class="$style.commonRadio"
                v-model="item.cashType"
                @click.native.prevent="handleRadio('0',index)"
                label="0">{{ $t('common.Currency') }}</el-radio>
              <el-radio
                :class="$style.commonRadio"
                v-model="item.cashType"
                @click.native.prevent="handleRadio('1',index)"
                label="1">{{ $t('common.Travellerscheque') }}</el-radio>
              <el-radio
                :class="$style.commonRadio"
                v-model="item.cashType"
                @click.native.prevent="handleRadio('2',index)"
                label="2">{{ $t('common.Cheque') }}</el-radio>
              <el-radio
                :class="$style.commonRadio"
                v-model="item.cashType"
                @click.native.prevent="handleRadio('3',index)"
                label="3">{{ $t('common.Billofexchange') }}</el-radio>
              <el-radio
                :class="$style.commonRadio"
                v-model="item.cashType"
                @click.native.prevent="handleRadio('4',index)"
                label="4">{{ $t('common.MoneyOrder') }}</el-radio>
              <el-radio
                :class="$style.commonRadio"
                v-model="item.cashType"
                @click.native.prevent="handleRadio('5',index)"
                label="5">{{ $t('common.PromissoryNote') }}</el-radio>
              <el-radio
                :class="$style.commonRadio"
                v-model="item.cashType"
                @click.native.prevent="handleRadio('6',index)"
                label="6">{{ $t('common.Others') }}</el-radio>
              <el-input
                v-if="item.cashType === '6'"
                :class="$style.ortherInput"
                v-model="item.cashTypeOth"
                :placeholder="$t('common.placeholder')"
                :ref="`otherInputs${index}`"/>
              <!-- <el-input
                :class="$style.ortherInput"
                v-model="item.cashTypeOth"
                ref="otherInputs"/> -->
            </el-form-item>
          </td>
        </tr>

        <tr align="center">
          <td>{{ $t('common.Currencyname') }} </td>
          <td colspan="3" style="padding: 5px;">
            <el-form-item style="margin: 0;">
              <el-select
                v-model="item.currencyType"
                :class="$style.input"
                clearable
                filterable
                :placeholder="$t('common.Pleaseselect')">
                <el-option
                  v-for="i in currencyTypeList"
                  :label="i.name"
                  :value="i.code"
                  :key="i.code"/>
              </el-select>
            </el-form-item>
          </td>
          <td colspan="2">{{ $t('common.Amounttonearestwholenumber') }}</td>
          <td colspan="2" style="padding: 5px; border-right: none;">
            <el-form-item style="margin: 0;">
              <!-- <el-input :class="$style.input" @input="(value)=>handleNumber(value, index)" v-model="item.money"/> -->
              <!-- <el-input
                :class="$style.input"
                v-model="item.moneyString"
                @blur.stop="formatMoneyBlur(index)"
                @input="(value)=>handleMoney(value,index)"
                @focus.stop="formatMoneyFocus(index)"/> -->
              <el-input
                :class="$style.input"
                v-model="item.moneyString"
                :placeholder="$t('common.placeholder')"
                @input="(value)=>handleMoney(value,index)"/>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td
            align="center"
            :style="(form.list[index].myself === '' ||
              form.list[index].myself === '1') ? 'border-bottom: none' : ''">{{ $t('common.Doesthedeclarantownthisitem') }}:</td>
          <td
            colspan="7"
            style="border-right: none;"
            :style="(form.list[index].myself === '' ||form.list[index].myself === '1') ? 'border-bottom: none' : ''">
            <el-form-item style="margin: 0 0 0 15px;">
              <el-radio
                :class="$style.commonRadio"
                v-model="item.myself"
                @click.native.prevent="handleMyselfClick('1',index)"
                label="1">{{ $t('common.Yes') }}</el-radio>
              <el-radio
                :class="$style.commonRadio"
                v-model="item.myself"
                @click.native.prevent="handleMyselfClick('0',index)"
                label="0">{{ $t('common.No') }}</el-radio>
              <span>({{ $t('common.theownershouldbeidentifiedontheappropriatefieldofPartIII') }})</span>
              <el-button
                type="primary"
                :class="$style.checked"
                v-if="index > 0 && item.myself === '0'
                  && form.list[0].myself === '0'"
                @click="synchronization(item,index)">
                {{ item.btnMsg }}
              </el-button>
              <!-- <el-button
                type="primary"
                :class="$style.checked"
                v-if="index > 0 && item.myself === '0'
                  && form.list[0].myself === '0'&& $store.getters.language === 'pr'"
                @click="synchronization1(item,index)">{{ item.btnMsg }}</el-button>
              <el-button
                type="primary"
                :class="$style.checked"
                v-if="index > 0 && item.myself === '0'
                  && form.list[0].myself === '0'&& $store.getters.language === 'us'"
                @click="synchronization2(item,index)">{{ item.btnMsg }}</el-button> -->
              <!-- <el-checkbox
                v-model="item.checked"
                style="position: absolute; margin-left: 20px;">同上一項</el-checkbox> -->
            </el-form-item>

          </td>
        </tr>
        <tr v-if="form.list[index].myself === '0'">
          <td
            colspan="2">
            <el-form-item style="margin: 0 0 0 15px;">
              <el-radio
                @change="handleName(index)"
                :class="$style.commonRadio"
                v-model="item.dataType"
                style="margin-right: 10px;"
                label="0">{{ $t('common.LegalPersonCorporatename') }}:</el-radio>
              <el-input
                :class="$style.ortherInput"
                v-if="item.dataType==='0'"
                :placeholder="$t('common.placeholder')"
                :ref="`nameInputOne${index}`"
                v-model="item.name"/>
              <el-input
                :placeholder="$t('common.placeholder')"
                :class="$style.ortherInput"
                v-if="item.dataType==='1'"/>
            </el-form-item>
          </td>
          <td
            style="border-right: none;"
            colspan="8">
            <el-form-item style="margin: 0 0 0 15px;">
              <el-radio
                @change="handleName(index)"
                :class="$style.commonRadio"
                v-model="item.dataType"
                label="1">{{ $t('common.IndividualName') }}:</el-radio>
              <el-input
                :class="$style.ortherInput"
                :ref="`nameInputTwo${index}`"
                :placeholder="$t('common.placeholder')"
                v-if="item.dataType==='1'"
                v-model="item.name"/>
              <el-input
                :class="$style.ortherInput"
                :placeholder="$t('common.placeholder')"
                v-if="item.dataType==='0'"/>
              <el-radio
                :disabled="item.disabled"
                :class="$style.commonRadio"
                v-model="item.gender"
                label="0">{{ $t('common.M') }}</el-radio>
              <el-radio
                :disabled="item.disabled"
                :class="$style.commonRadio"
                v-model="item.gender"
                label="1">{{ $t('common.F') }}</el-radio>
            </el-form-item>
            <el-form-item style="margin: 0;"/>
          </td>
        </tr>
        <tr v-if="form.list[index].myself === '0'">
          <td
            colspan="2"
            align="center"
            style="border-bottom: none;">{{ $t('common.Address') }}</td>
          <td
            colspan="7"
            style="padding: 5px; border-bottom: none; border-right: none;">
            <el-form-item style="margin: 0;">
              <el-input
                :placeholder="$t('common.placeholder')"
                maxlength="500"
                :class="$style.input"
                v-model="item.address"/>
            </el-form-item>
          </td>
        </tr>
        <div :class="$style.del" v-show="item.delBtn" @click="del(item,index)">
          {{ $t('common.del') }}
        </div>
      </table>
      <div :class="$style.btn" @click="add" v-show="isShow">
        <img src="@/assets/add.png" alt=""/>
        {{ $t('common.add') }}
      </div>
      <!-- <common-title>{{ $t('common.PartIII') }}</common-title> -->
      <!-- <table
        v-for="(item,index) in form.list"
        :key="index"
        cellpadding="0"
        cellspacing="0"
        :class="$style.table"
        border="1px">
        <tr v-if="$store.getters.language === 'cn'">
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
          <th style="width: 10%; height: 0; border: none;"/>
        </tr>
        <tr>
          <td
            :style="form.list[index].myself === '1' || form.list[index].myself === ''? 'background: #F5F7FA;' : null"
            rowspan="2"
            align="center">{{ index === 0 ? $t('common.item1') : index === 1 ? $t('common.item2') : $t('common.item3') }}</td>
          <td
            colspan="4"
            :style="form.list[index].myself === '1' || form.list[index].myself === ''? 'background: #F5F7FA;' : null">
            <el-form-item style="margin: 0 0 0 15px;">
              <el-radio
                @change="handleName(index)"

                :class="$style.commonRadio"
                v-model="item.dataType"
                label="0">{{ $t('common.LegalPersonCorporatename') }}:</el-radio>
              <el-input
                :disabled="form.list[index].myself === '1' || form.list[index].myself === ''"
                :class="$style.ortherInput"
                v-if="item.dataType==='0'"
                :ref="`nameInputOne${index}`"
                v-model="item.name"/>
              <el-input
                :disabled="form.list[index].myself === '1' || form.list[index].myself === ''"
                :class="$style.ortherInput"
                v-if="item.dataType==='1'"/>
            </el-form-item>
          </td>
          <td
            colspan="4"
            :style="form.list[index].myself === '1' || form.list[index].myself === ''? 'background: #F5F7FA;' : null">
            <el-form-item style="margin: 0 0 0 15px;">
              <el-radio
                @change="handleName(index)"
                :disabled="form.list[index].myself === '1' || form.list[index].myself === ''"
                :class="$style.commonRadio"
                v-model="item.dataType"
                label="1">{{ $t('common.IndividualName') }}:</el-radio>
              <el-input
                :class="$style.ortherInput"
                :disabled="form.list[index].myself === '1' || form.list[index].myself === ''"
                :ref="`nameInputTwo${index}`"
                v-if="item.dataType==='1'"
                v-model="item.name"/>
              <el-input
                :class="$style.ortherInput"
                :disabled="form.list[index].myself === '1' || form.list[index].myself === ''"
                v-if="item.dataType==='0'"/>
              <el-radio
                :disabled="form.list[index].myself === '1' || form.list[index].myself === '' || form.list[index].dataType === '0'"
                :class="$style.commonRadio"
                v-model="item.gender"
                label="0">{{ $t('common.M') }}</el-radio>
              <el-radio
                :disabled="form.list[index].myself === '1' || form.list[index].myself === '' || form.list[index].dataType === '0'"
                :class="$style.commonRadio"
                v-model="item.gender"
                label="1">{{ $t('common.F') }}</el-radio>
            </el-form-item>
            <el-form-item style="margin: 0;"/>
          </td>
        </tr>
        <tr>
          <td
            :style="form.list[index].myself === '1' || form.list[index].myself === ''? 'background: #F5F7FA; color: #c0c4cc;' : null"
            colspan="2"
            align="center">{{ $t('common.Address') }}</td>
          <td
            colspan="7"
            style="border: none;"
            :style="form.list[index].myself === '1' || form.list[index].myself === ''? 'background: #F5F7FA;' : null">
            <el-form-item style="margin: 0;">
              <el-input
                :class="$style.input"
                :disabled="form.list[index].myself === '1' || form.list[index].myself === ''"
                v-model="item.address"/>
            </el-form-item>
          </td>
        </tr>
      </table> -->
      <common-title style="margin-top: 20px;">
        {{ $t('common.PartIV') }}
        <span>*{{ $t('common.required') }}</span>
      </common-title>
      <div :class="$style.statement">
        <span :class="$style.red">*</span><el-checkbox v-model="isAllow"><span :class="$style.allowInfo">
          <!-- 本人聲明已閱讀
        </span></el-checkbox>
        <span :class="$style.allowInfo"><a @click="handleShow">《申報須知》</a>，並聲明所填寫的資料屬實和完整。</span> -->
          <span :class="$style.allowInfo"><a @click="handleShow">{{ $t('common.Ideclare') }}</a></span></span></el-checkbox>
      </div>
      <div :class="$style.statement" style="margin-left: 7px;">
        <el-checkbox
          v-model="allowCookis">
          <span :class="$style.allowInfo">
            <!-- 選中後允許系統獲得用戶的Cookies使用權限，則下次申報直接獲取上次填寫的數據。 -->
            {{ $t('common.Keepthefilinginformation') }}
          </span>
        </el-checkbox>
      </div>
      <div :class="$style.statement">
        <el-form-item prop="key" :class="$style.otherInput">
          <el-input
            v-model="form.key"
            ref="Verification"
            :placeholder="$t('common.Pleasepresstheicontoentertheverificationcode')"/>
        </el-form-item>
        <img :src="Verification"/>
        <a @click="getVerification" :class="$style.other">{{ $t('common.Cannotseeclearly') }}</a>

      </div>
      <div :class="$style.buttonBox">
        <el-button :class="$style.button" type="primary" @click="handleReset">{{ $t('common.Reset') }}</el-button>
        <el-button :class="$style.button" type="primary" @click="handleSave">{{ $t('common.Submit') }}</el-button>
      </div>
    </div>
    <el-dialog
      center
      :visible.sync="successVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @close="handleqrcodeVIsible"
      width="30%">
      <template #title>
        <div :class="$style.qrcodeTitle"><i class="el-icon-success"/>
          {{ $t('common.Thesubmissionwassuccessful') }}!
        </div></template>
      <div :class="$style.qrcode">
        <div :class="$style.imgBox">
          <img :src="QRcode"/>
        </div>
        <el-button type="primary" @click="handleSaveClick"><span>{{ $t('common.Save') }}</span></el-button>
        <span>
          {{ $t('common.pleasekeepthisQRcode') }}
        </span>
        <el-button type="primary" :class="$style.close" @click="handleqrcodeVIsible">{{ $t('common.Close') }}</el-button>
      </div>
      <el-dialog
        width="30%"
        :title="$t('common.Tips')"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="innerVisible"
        append-to-body>
        <span style="fonts-size: 18px;">{{ $t('common.QRcodepicturesarerequired') }}</span>
        <template #footer>
          <el-button @click="innerVisible=false">{{ $t('common.Savethepicture') }}</el-button>
          <el-button
            type="primary"
            @click="hendleYesClick">{{ $t('common.Stillexit') }}</el-button>
        </template>
      </el-dialog>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible"
      class="dialog"
      width="60%">
      <template #title><span :class="$style.infoTitle">{{ $t('common.Statement') }}</span></template>
      <div :class="$style.infoBox">
        <div :class="$style.info">
          <c-info type="1"/>
        </div>
        <el-button :class="$style.close" type="primary" @click="dialogVisible = false">{{ $t('common.OK') }}</el-button>
      </div>
    </el-dialog>
  </el-form>
</template>

<script>
  import { Button, Form, Input,
           Radio, DatePicker, Select, Option, FormItem,
           Checkbox, Dialog, Message, MessageBox } from "element-ui";
  import Info from "../../components/info";
  import api from "../../api";
  import { commonTitle } from "./components";
  import filters from "../../filters";
  import downloadImg from "../../utils/downloadImg";
  import CryptoJS from "crypto-js";
  export default {
    name: "Pc",
    components: {
      "el-button": Button,
      "el-form": Form,
      "el-input": Input,
      // "el-autocomplete": Autocomplete,
      "el-date-picker": DatePicker,
      "el-dialog": Dialog,
      "el-select": Select,
      "el-option": Option,
      "el-form-item": FormItem,
      "el-radio": Radio,
      "c-info": Info,
      "el-checkbox": Checkbox,
      commonTitle
    },
    props: {
    },
    computed: {
      languageTypeData () {
        return this.$store.state.language;
      }
    },
    watch: {
      languageTypeData () {
        // console.log(`${this.$t("common.confirmDelete")}`);
        // if (val === "cn") {
        //   console.log(this.form.list);
        //   this.form
        // }
        // console.log(1);
        this.form.list.forEach(item => {
          if (item.i === 0) {
            item.btnMsg = `${this.$t("common.synchronizationText")}`;
          } else {
            item.btnMsg = `${this.$t("common.cancelSynchronizationText")}`;
          }
        });
        this.getCurrency();
        this.getCountry();
        this.getDictionary();
      },
      "$route.query.index" (val) {
        console.log(val);
      },
      form: {
        handler (value) {
          if (value.key !== "") {
            this.$refs.Verification.$el.children[0].style.border = "1px solid #DCDFE6";
          }
          if (value.list.length === 30) {
            this.isShow = false;
          } else {
            this.isShow = true;
          }
          // eslint-disable-next-line array-callback-return
          // value.list.map(item => {
          //   if (item.cashType !== "6") {
          //     item.cashTypeOth = "";
          //   }
          // if (this.form.list[index].cashType !== "6") {
          //   this.form.list[index].cashTypeOth = "";
          // }
          // });
        },
        deep: true
      }
    },
    data () {
      // const validatePhone = (rule, value, callback) => {
      //   if (this.phoneTitle === "") {
      //     callback(new Error(this.$t("common.Pleaseentertheareacode")));
      //   } else {
      //     callback();
      //   }
      // };
      return {
        loading: false,
        restaurants: [],
        options: [],
        isShow: true,
        active: "",
        isTop: true,
        form: {
          delBtn: false,
          name: "",
          gender: "",
          nationality: "",
          birthplace: "",
          birthTime: "",
          address: "",
          phone: "",
          documentNum: "",
          documentType: "",
          issue: "",
          entryExitType: "",
          entryExit: "",
          key: "",
          list: [
            {
              cashType: "",
              cashTypeOth: "",
              currencyType: "",
              money: "",
              moneyString: "",
              myself: "",
              dataType: "",
              name: "",
              gender: "",
              sequence: "",
              id: this.guid(),
              address: "",
              delBtn: false,
              btnMsg: `${this.$t("common.synchronizationText")}`,
              i: 0,
              disabled: false
            }
            // {
            //   cashType: "",
            //   cashTypeOth: "",
            //   currencyType: "",
            //   money: "",
            //   moneyString: "",
            //   myself: "",
            //   dataType: "",
            //   name: "",
            //   gender: "",
            //   sequence: 2,
            //   address: ""
            // },
            // {
            //   cashType: "",
            //   cashTypeOth: "",
            //   currencyType: "",
            //   money: "",
            //   moneyString: "",
            //   myself: "",
            //   dataType: "",
            //   name: "",
            //   gender: "",
            //   sequence: 3,
            //   address: ""
            // }
          ]
        },
        countyList: [],
        documentList: [],
        isAllow: false,
        allowCookis: false,
        dialogVisible: false,
        successVisible: false,
        isClicked: false,
        innerVisible: false,
        phoneTitle: "",
        formType: true,
        indexs: null,
        currencyTypeList: [],
        rules: {
          name: [
            { required: true, message: "請輸入您的姓名", trigger: "blur" }
          ],
          // key: [
          //   { required: true, message: "請輸入驗證碼", trigger: "blur" }
          // ],
          // nationality: [
          //   { required: true, message: "請輸入您的國籍", trigger: "blur" }
          // ],
          gender: [
            { required: true, message: "請選擇您的性別", trigger: "blur" }
          ],
          // birthplace: [
          //   { required: true, message: "請輸入您的出生地", trigger: "blur" }
          // ],
          // birthTime: [
          //   { required: true, message: "請輸入您的出生日期", trigger: "blur"}
          // ],
          documentNum: [
            { required: true, message: "請選擇您的證件類別", trigger: "blur" }
          ],
          documentType: [
            { required: true, message: "請輸入您的證件號碼", trigger: "blur" }
          ]
          // issue: [
          //   { required: true, message: "請輸入您的簽發地", trigger: "blur" }
          // ],
          // address: [
          //   { required: true, message: "請輸入您的永久居所住址", trigger: "blur" }
          // ],
          // phone: [
          //   { required: true, message: "請輸入您的聯絡電話", trigger: "blur" }
          // ],
          // phoneTitle: [
          //   { validator: validatePhone, trigger: "blur" }
          // ],
          // entryExit: [
          //   { required: true, trigger: "blur" }
          // ]
        },
        QRcode: "",
        VerificationID: "",
        Verification: "",
        seafKey: ""
      };
    },
    methods: {
      synchronization (item, idx) {
        if (this.form.list[idx].btnMsg === `${this.$t("common.synchronizationText")}`) {
          this.form.list[idx].btnMsg = `${this.$t("common.cancelSynchronizationText")}`;
          this.form.list[idx].i = 1;
          this.form.list[idx].address = this.form.list[0].address;
          this.form.list[idx].dataType = this.form.list[0].dataType;
          this.form.list[idx].name = this.form.list[0].name;
          this.form.list[idx].gender = this.form.list[0].gender;
        } else {
          this.form.list[idx].btnMsg = `${this.$t("common.synchronizationText")}`;
          this.form.list[idx].i = 0;
          this.form.list[idx].address = "";
          this.form.list[idx].dataType = "";
          this.form.list[idx].name = "";
          this.form.list[idx].gender = "";
        }
      },
      GetEntryExit () {
        api.getEntryExit().then(res => {
          this.options = res;
        });
      },
      mouseOvers () {
        this.isTop = false;
      },
      mouseLeaves () {
        this.isTop = true;
      },
      top () {
        document.body.scrollIntoView();
      },
      // 鼠標移入
      mouseOver (index) {
        if (this.form.list.length > 1) {
          this.form.list[index].delBtn = true;
          this.form.list[index].active = "border: 1px solid #43a6df";
        }
      },
      // 鼠標移除
      mouseLeave (index) {
        this.form.list[index].delBtn = false;
        this.form.list[index].active = "border: 1px solid #adadad";
      },
      del (item, idx) {
        // this.form.list.map(item => {
        //   item.sequence = this.form.list.length + 1;
        //   return item;
        // });
        MessageBox.confirm(`${this.$t("common.confirmDelete")}`, `${this.$t("common.warn")}`, {
          confirmButtonText: `${this.$t("common.confirm")}`,
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.form.list.splice(idx, 1);
        });


      },
      add () {
        if (this.form.list.length < 30) {
          this.form.list.push({
            cashType: "",
            currencyType: "",
            cashTypeOth: "",
            money: "",
            moneyString: "",
            myself: "",
            dataType: "",
            name: "",
            gender: "",
            id: this.guid(),
            sequence: "",
            address: "",
            delBtn: false,
            btnMsg: `${this.$t("common.synchronizationText")}`,
            i: 0,
            disabled: false
          });
        }
      },
      guid () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
          const r = Math.random() * 16 | 0,
                v = c === "x" ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      },
      handleShow () {
        this.dialogVisible = true;
      },
      handleReset () {
        this.getVerification();
        this.phoneTitle = "";
        this.form = {
          name: "",
          gender: "",
          nationality: "",
          birthplace: "",
          birthTime: "",
          address: "",
          phone: "",
          key: "",
          documentNum: "",
          documentType: "",
          issue: "",
          entryExitType: "",
          entryExit: "",
          list: [
            {
              cashType: "",
              currencyType: "",
              cashTypeOth: "",
              money: "",
              moneyString: "",
              myself: "",
              dataType: "",
              name: "",
              gender: "",
              sequence: 1,
              address: "",
              delBtn: false,
              btnMsg: `${this.$t("common.synchronizationText")}`
            }
            // {
            //   cashType: "",
            //   currencyType: "",
            //   cashTypeOth: "",
            //   money: "",
            //   moneyString: "",
            //   myself: "",
            //   dataType: "",
            //   name: "",
            //   gender: "",
            //   sequence: 2,
            //   address: ""
            // },
            // {
            //   cashType: "",
            //   currencyType: "",
            //   cashTypeOth: "",
            //   money: "",
            //   moneyString: "",
            //   myself: "",
            //   dataType: "",
            //   name: "",
            //   gender: "",
            //   sequence: 3,
            //   address: ""
            // }
          ]
        };
      },
      getVerification () {
        api.getVerification().then(res => {
          this.VerificationID = res.imgId;
          this.Verification = res.img;
        });
      },
      handleCheck () {
        this.formType = true;
        if (this.form.list[0].cashType === "" && this.form.list[0].money === "" && this.form.list[0].currencyType === "") {
          Message({
            message: this.$t("common.Pleaseenterthefirstitem"),
            type: "warning",
            duration: 6000
          });
          this.formType = false;
          return;
        }
        // eslint-disable-next-line array-callback-return
        this.form.list.map((item, index) => {
          if (item.cashType !== "") {
            if (item.money === "") {
              Message({
                // message: `請輸入第二部分第${filters.numChange(index + 1)}項數額`,
                // message: this.$t(`common.Pleaseamount${index + 1}`),
                message: this.$t(`common.amount${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.currencyType === "") {
              Message({
                // message: `請輸入第二部分第${filters.numChange(index + 1)}項貨幣名稱`,
                // message: this.$t(`common.Pleasecurrency${index + 1}`),
                message: this.$t("common.currencyName"),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.myself === "") {
              Message({
                // message: `請選擇第二部分第${filters.numChange(index + 1)}項是否屬於聲明人所有`,
                message: this.$t(`common.Pleasewhether${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            }
          } else if (item.money !== "") {
            if (item.cashType === "") {
              Message({
                // message: `請選擇第二部分第${filters.numChange(index + 1)}項貨幣類型`,
                message: this.$t(`common.Pleasecurrencytype${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.currencyType === "") {
              Message({
                // message: `請輸入第二部分第${filters.numChange(index + 1)}項貨幣名稱`,
                message: this.$t(`common.Pleasecurrency${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.myself === "") {
              Message({
                // message: `請選擇第二部分第${filters.numChange(index + 1)}項是否屬於聲明人所有`,
                message: this.$t(`common.Pleasewhether${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            }
          } else if (item.currencyType !== "") {
            if (item.money === "") {
              Message({
                // message: `請輸入第二部分第${filters.numChange(index + 1)}項數額`,
                message: this.$t(`common.Pleaseamount${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.cashType === "") {
              Message({
                // message: `請選擇第二部分第${filters.numChange(index + 1)}項貨幣類型`,
                message: this.$t(`common.Pleasecurrencytype${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.myself === "") {
              Message({
                // message: `請選擇第二部分第${filters.numChange(index + 1)}項是否屬於聲明人所有`,
                message: this.$t(`common.Pleasewhether${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            }
          } else if (item.myself !== "") {
            if (item.money === "") {
              Message({
                // message: `請輸入第二部分第${filters.numChange(index + 1)}項數額`,
                message: this.$t(`common.Pleaseamount${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.cashType === "") {
              Message({
                // message: `請選擇第二部分第${filters.numChange(index + 1)}項貨幣類型`,
                message: this.$t(`common.Pleasecurrencytype${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.currencyType === "") {
              Message({
                // message: `請輸入第二部分第${filters.numChange(index + 1)}項貨幣名稱`,
                message: this.$t(`common.Pleasecurrency${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            }
          }
          if (item.myself === "0") {
            // dataType
            // name
            // address
            if (item.dataType === "" && item.name === "" && item.address === "") {
              Message({
                // message: `請輸入第三部分第${filters.numChange(index + 1)}項`,
                message: this.$t(`common.PleasePartIII${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.dataType !== "" && item.address === "") {
              Message({
                // message: `請輸入第三部分第${filters.numChange(index + 1)}項永久居住住址`,
                message: this.$t(`common.PleasePartaddressIII${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.dataType === "" && item.address !== "") {
              Message({
                // message: `請輸入第三部分第${filters.numChange(index + 1)}項法人/自然人姓名`,
                message: this.$t(`common.PleasePartpersonIII${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            } else if (item.dataType !== "" && item.address !== "" && item.name === "") {
              Message({
                // message: `請輸入第三部分第${filters.numChange(index + 1)}項法人/自然人姓名`,
                message: this.$t(`common.PleasePartpersonIII${index + 1}`),
                type: "warning",
                duration: 6000
              });
              this.formType = false;
              // eslint-disable-next-line array-callback-return
              return;
            }
          }
        });
      },
      handleTrim (data) {
        // eslint-disable-next-line no-return-assign
        return data = data.replace(/^\s+|\s+$/g, "");
      },
      handleSave () {

        // const testData = [
        //   {
        //     money:'112321312'
        //   },
        //   {
        //     money:'-1'
        //   },
        // ]
        // // 校验 money 字段是否包含汉字
        // const chineseRegex = /[\u4e00-\u9fa5]/;
        // for (let i = 0; i < testData.length; i++) {
        //   if (testData[i].money && chineseRegex.test(testData[i].money)) {
        //     Message({ type: "warning", message: this.$t("common.Pleaseentertheamount") });
        //     return;
        //   }

        //   // 新增：校验 money 是否为 0 或正整数
        //   const moneyVal = testData[i].money;
        //   // 注意：如果 money 可能为 undefined/null/空字符串，根据业务决定是否允许
        //   if (moneyVal !== undefined && moneyVal !== null && moneyVal !== '') {
        //     // 转为数字（如果是字符串数字）
        //     const num = Number(moneyVal);
        //     // 判断是否为整数且 >= 0，并且不是 NaN/无穷
        //     if (!Number.isInteger(num) || num < 0) {
        //       Message({ type: "warning", message: this.$t("common.Pleaseentertheamount") });
        //       return;
        //     }
        //   } else {
        //     // 如果 money 为空且不允许为空，可在这里处理；如果允许为空则跳过
        //   }
        // }




        // eslint-disable-next-line consistent-return
        // this.$refs["ruleForm"].validate(valid => {
        // if (valid) {
        // this.handleCheck();
        if (this.formType === true) {
          // 判斷是否同意聲明須知;
          if (this.isAllow) {
            if (this.form.key !== "") {
              // eslint-disable-next-line consistent-return
              // const encryptor = new this.$jsEncrypt();
              // const aseKey = "sde@5f98H*^hsff%dfs$r344&df8543*er";
              // const key = CryptoJS.enc.Utf8.parse("sde@5f98H*^hsff%dfs$r344&df8543*er");
              // encryptor.setKey(this.seafKey);
              this.form.list = this.form.list.map((item, idx) => {
                item.sequence = idx + 1;
                return item;
              });
              const data = {...this.form};
              // return;
              data.nationality = this.handleTrim(data.nationality);
              data.birthplace = this.handleTrim(data.birthplace);
              data.name = this.handleTrim(data.name);
              data.address = this.handleTrim(data.address);
              data.documentNum = this.handleTrim(data.documentNum);
              data.issue = this.handleTrim(data.issue);
              data.entryExit = this.handleTrim(data.entryExit);
              // eslint-disable-next-line array-callback-return
              data.list.map(item => {
                item.name = this.handleTrim(item.name);
                item.address = this.handleTrim(item.address);
              });
              data.phone = (this.phoneTitle && data.phone) ? `${this.phoneTitle}-${data.phone}` : "";
              // if (this.phoneTitle === "" || data.phone === "") {
              //   data.phone = "";
              // } else {
              //   data.phone = `${this.phoneTitle}-${data.phone}`;
              // }
              data.list = data.list.filter(item => {
                return item.cashType !== "" || item.money !== "" ||
                  item.currencyType !== "" || item.moneyString !== "" ||
                  item.myself !== "";
              });

              // 校验 money 字段是否包含汉字
              const chineseRegex = /[\u4e00-\u9fa5]/;
              for (let i = 0; i < data.list.length; i++) {
                /* eslint-disable max-depth */
                if (data.list[i].money && chineseRegex.test(data.list[i].money)) {
                  Message({ type: "warning", message: this.$t("common.Pleaseentertheamount") });
                  return;
                }

                // 新增：校验 money 是否为 0 或正整数
                const moneyVal = data.list[i].money;
                // 注意：如果 money 可能为 undefined/null/空字符串，根据业务决定是否允许
                if (moneyVal !== undefined && moneyVal !== null && moneyVal !== "") {
                  // 转为数字（如果是字符串数字）
                  const num = Number(moneyVal);
                  // 判断是否为整数且 >= 0，并且不是 NaN/无穷
                  if (!Number.isInteger(num) || num < 0) {
                    Message({ type: "warning", message: this.$t("common.Pleaseentertheamount") });
                    return;
                  }
                } else {
                  // 如果 money 为空且不允许为空，可在这里处理；如果允许为空则跳过
                }
              }

              // eslint-disable-next-line no-return-assign
              data.list.map(item => item.money = filters.delcommafy(item.money));
              data.key = `${this.VerificationID}${data.key}`;
              data.birthTime = filters.datePick(data.birthTime);
              const languageType = this.$store.state.language === "cn" ? 0 : this.$store.state.language === "us" ? 1 : 2;
              data.language = languageType;
              delete data.id;
              // const params = encryptor.encryptLong(JSON.stringify(data));
              // const encrypt = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
              //   iv: CryptoJS.enc.Utf8.parse(aseKey.substr(0, 16)),
              //   mode: CryptoJS.mode.CBC,
              //   padding: CryptoJS.pad.Pkcs7
              // });
              // const data2 = encrypt.toString();
              // console.log("未加密数据", data);
              // console.log("加密数据", this.encrypt(JSON.stringify(data)));
              // console.log("未加密数据", data);
              // const params = encryptor.encryptLong2(JSON.stringify(data));
              const data1 = this.encrypt(JSON.stringify(data));
              console.log("未加密数据", data);
              api.insertCashInternet(data1).then(res => {

                this.QRcode = res[0].qrCode;
                this.successVisible = true;
                this.isClicked = false;
                console.log(this.allowCookis);
                if (this.allowCookis === true) {
                  // const obj = {...this.form};
                  const obj = res[0];
                  // console.log(res[0]);
                  obj.nationality = this.handleTrim(obj.nationality);
                  obj.birthplace = this.handleTrim(obj.birthplace);
                  obj.name = this.handleTrim(obj.name);
                  obj.address = this.handleTrim(obj.address);
                  obj.documentNum = this.handleTrim(obj.documentNum);
                  obj.issue = this.handleTrim(obj.issue);
                  // obj.entryExit = this.handleTrim(obj.entryExit);
                  // obj.entryExit = "";
                  // obj.entryExitType = "";
                  // eslint-disable-next-line array-callback-return
                  // obj.list.map(item => {
                  //   item.name = this.handleTrim(item.name);
                  //   item.address = this.handleTrim(item.address);
                  // });
                  // obj.phone = `${this.phoneTitle}-${obj.phone}`;
                  obj.QRcode = res[0].qrCode;
                  // for (let i = 0; i < obj.list.length; i++) {
                  //   obj.list[i].money = "";
                  //   obj.list[i].moneyString = "";
                  // }
                  // eslint-disable-next-line no-return-assign
                  // obj.list.map(item => {
                  //   item.money = "";
                  //   item.moneyString = "";
                  // });
                  obj.time = new Date();
                  delete obj.list;
                  // console.log(obj);
                  // delete obj.id;
                  if (this.indexs !== null) {
                    // const pageData = JSON.parse(localStorage.getItem("pageData"));
                    // pageData[this.indexs] = obj;
                    // localStorage.setItem("pageData", JSON.stringify(pageData));
                    const pageData = localStorage.getItem("pageData") ? JSON.parse(localStorage.getItem("pageData")) : [];
                    pageData.push(obj);
                    pageData.reverse();
                    localStorage.setItem("pageData", JSON.stringify(pageData));
                  } else {
                    const pageData = localStorage.getItem("pageData") ? JSON.parse(localStorage.getItem("pageData")) : [];
                    pageData.push(obj);
                    pageData.reverse();
                    localStorage.setItem("pageData", JSON.stringify(pageData));
                  }
                }
                Message({
                  message: this.$t("common.Thesavewassuccessful"),
                  type: "success"
                });
                this.getVerification();
              }).catch(() => {
                this.getVerification();
              });
            }
            if (this.form.key === "") {
              Message({
                message: this.$t("common.Pleaseentertheverificationcode"),
                type: "warning",
                duration: 6000
              });
            }
            // 判斷是否填寫驗證碼

            this.$refs.Verification.$el.children[0].style.border = "1px solid #F56C6C";
            this.getVerification();

          } else {
            // 判斷是否閱讀申報須知
            Message({
              message: this.$t("common.Pleasemakesuretoreadthedeclaration"),
              type: "warning",
              duration: 6000
            });
            this.getVerification();
          }
        } else {
          // 檢驗第三部分數據f
          this.getVerification();
        }
        // } else {
        //   // 表單驗證
        //   // if (Object.keys(error).length === 1 && error.key) {
        //   //   Message({
        //   //     message: "請輸入驗證碼",
        //   //     type: "warning"
        //   //   });
        //   // } else {
        //   //   window.scrollTo(0, 0);
        //   //   Message({
        //   //     message: "表單有誤",
        //   //     type: "warning"
        //   //   });
        //   // }
        //   window.scrollTo(0, 0);
        //   Message({
        //     message: this.$t("common.Personaldata"),
        //     type: "warning",
        //     duration: 6000
        //   });
        //   this.getVerification();
        //   return false;
        // }
        // });
      },
      // 加密
      encrypt (word) {
        const key = CryptoJS.enc.Utf8.parse("abcdefgabcdefg12");
        const srcs = CryptoJS.enc.Utf8.parse(word);
        const encrypted = CryptoJS.AES.encrypt(srcs, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
        return encrypted.ciphertext.toString();
      },
      handleSaveClick () {
        const name = `${this.form.name}${filters.Qrcodetime(new Date())}.jpg`;
        this.isClicked = true;
        downloadImg(this.QRcode, name);
      },
      getkey () {
        api.getKey().then(res => {
          this.seafKey = res;
        });
      },
      getCurrency () {
        const data = this.$store.state.language === "cn" ? 0 : this.$store.state.language === "us" ? 1 : 2;
        api.getCurrency({language: data}).then(res => {
          this.currencyTypeList = [];
          // eslint-disable-next-line array-callback-return
          res.map(item => this.currencyTypeList.push({
            name: `${item.name}`,
            code: item.code
          }));
          // switch (this.$store.state.language) {
          // case "cn" : {
          //   // eslint-disable-next-line array-callback-return
          //   res.map(item => this.currencyTypeList.push({
          //     name: `${item.name}`,
          //     code: item.code
          //   }));
          //   break;
          // }
          // case "us" : {
          //   // eslint-disable-next-line array-callback-return
          //   res.map(item => this.currencyTypeList.push({
          //     name: `${item.en}`,
          //     code: item.code
          //   }));
          //   break;
          // }
          // case "pr" : {
          //   // eslint-disable-next-line array-callback-return
          //   res.map(item => this.currencyTypeList.push({
          //     name: `${item.pr}`,
          //     code: item.code
          //   }));
          //   break;
          // }
          // }
        });
      },
      getCountry () {
        const data = this.$store.state.language === "cn" ? 0 : this.$store.state.language === "us" ? 1 : 2;
        api.getCountry({language: data}).then(res => {
          this.countyList = [];
          // console.log(res);
          // eslint-disable-next-line array-callback-return
          res.map(item => this.countyList.push({
            name: `${item.name}`,
            code: item.code
          }));
          // switch (this.$store.state.language) {
          // case "cn" : {
          //   // eslint-disable-next-line array-callback-return
          //   res.map(item => this.countyList.push({
          //     name: `${item.name}`,
          //     code: item.code
          //   }));
          //   break;
          // }
          // case "us" : {
          //   // eslint-disable-next-line array-callback-return
          //   res.map(item => this.countyList.push({
          //     name: `${item.en}`,
          //     code: item.code
          //   }));
          //   break;
          // }
          // case "pr" : {
          //   // eslint-disable-next-line array-callback-return
          //   res.map(item => this.countyList.push({
          //     name: `${item.pr}`,
          //     code: item.code
          //   }));
          //   break;
          // }
          // }
        });

      },
      getDictionary () {
        const data = this.$store.state.language === "cn" ? 0 : this.$store.state.language === "us" ? 1 : 2;
        api.getDictionary({language: data}).then(res => {
          this.documentList = [];
          // eslint-disable-next-line array-callback-return
          res.map(item => this.documentList.push({
            name: item.name,
            code: item.code
          }));
          // switch (this.$store.state.language) {
          // case "cn" : {
          //   // eslint-disable-next-line array-callback-return
          //   res.map(item => this.documentList.push({
          //     name: item.name,
          //     code: item.value
          //   }));
          //   break;
          // }
          // case "us" : {
          //   // eslint-disable-next-line array-callback-return
          //   res.map(item => this.documentList.push({
          //     name: item.en,
          //     code: item.value
          //   }));
          //   break;
          // }
          // case "pr" : {
          //   // eslint-disable-next-line array-callback-return
          //   res.map(item => this.documentList.push({
          //     name: item.pr,
          //     code: item.value
          //   }));
          //   break;
          // }
          // }
        });
      },
      handleNumber (value, index) {
        index === 1 ? this.phoneTitle = value.replace(/[^\d]/g, "") : this.form.phone = value.replace(/[^\d]/g, "");
      },
      // 處理入境出境男女
      handleClick (value, type) {
        if (type === 1) {
          this.form.entryExitType = value === this.form.entryExitType ? "" : value;
        } else {
          this.form.gender = value === this.form.gender ? "" : value;
        }
      },
      handleMyselfClick (value, index) {
        if (value === "1" || this.form.list[index].myself === value) {
          this.form.list[index].dataType = "";
          this.form.list[index].gender = "";
          this.form.list[index].name = "";
          this.form.list[index].address = "";
        }
        this.form.list[index].myself = value === this.form.list[index].myself ? "" : value;
      },
      handleName (index) {
        if (this.form.list[index].dataType === "0") {
          this.form.list[index].gender = "";
          this.form.list[index].disabled = true;
          const ref = this.$refs[`nameInputOne${index}`];
          setTimeout(() => {
            ref[0].focus();
          }, 1);
        } else if (this.form.list[index].dataType === "1") {
          this.form.list[index].disabled = false;
          const refs = this.$refs[`nameInputTwo${index}`];
          setTimeout(() => {
            refs[0].focus();
          }, 1);
        }
      },
      handleqrcodeVIsible (e) {
        e.stopPropagation();
        if (this.isClicked) {
          this.successVisible = false;
          this.$router.push({path: "/eDCBNI/Currency/List"});
          // this.form.key = "";
          // this.form.list = [
          //   {
          //     cashType: "",
          //     currencyType: "",
          //     money: "",
          //     moneyString: "",
          //     myself: "",
          //     dataType: "",
          //     name: "",
          //     gender: "",
          //     sequence: 1,
          //     address: ""
          //   },
          //   {
          //     cashType: "",
          //     currencyType: "",
          //     money: "",
          //     moneyString: "",
          //     myself: "",
          //     dataType: "",
          //     name: "",
          //     gender: "",
          //     sequence: 2,
          //     address: ""
          //   },
          //   {
          //     cashType: "",
          //     currencyType: "",
          //     money: "",
          //     moneyString: "",
          //     myself: "",
          //     dataType: "",
          //     name: "",
          //     gender: "",
          //     sequence: 3,
          //     address: ""
          //   }
          // ];
          return;
        }
        this.innerVisible = true;
      },
      hendleYesClick () {
        this.innerVisible = false;
        this.successVisible = false;
        this.$router.push({path: "/eDCBNI/Currency/List"});
        // this.form.key = "";
        // this.form.list = [
        //   {
        //     cashType: "",
        //     currencyType: "",
        //     money: "",
        //     moneyString: "",
        //     myself: "",
        //     dataType: "",
        //     name: "",
        //     gender: "",
        //     sequence: 1,
        //     address: ""
        //   },
        //   {
        //     cashType: "",
        //     currencyType: "",
        //     money: "",
        //     moneyString: "",
        //     myself: "",
        //     dataType: "",
        //     name: "",
        //     gender: "",
        //     sequence: 2,
        //     address: ""
        //   },
        //   {
        //     cashType: "",
        //     currencyType: "",
        //     money: "",
        //     moneyString: "",
        //     myself: "",
        //     dataType: "",
        //     name: "",
        //     gender: "",
        //     sequence: 3,
        //     address: ""
        //   }
        // ];
      },
      handleMoney (value, index) {
        this.form.list[index].moneyString = value.replace(/[^\d]/g, "");
        this.form.list[index].moneyString = filters.comdify(value);
        this.form.list[index].money = filters.delcommafy(value);
      },
      // 处理金额 千分位 小数点
      // formatMoneyBlur (num) {
      //   const oldVal = this.form.list[num].moneyString;
      //   if (oldVal) {
      //     const newVal = parseInt(oldVal);
      //     this.form.list[num].money = newVal;
      //     const formatVal = newVal.toLocaleString(newVal);
      //     this.form.list[num].moneyString = formatVal;
      //     // this.form.list[num].moneyString = formatVal + ".00";
      //   } else {
      //     this.form.list[num].money = "";
      //     this.form.list[num].moneyString = "";
      //   }
      // },
      // formatMoneyFocus (num) {
      //   this.form.list[num].moneyString = this.form.list[num].money;
      // },
      handleRadio (v, index) {
        this.form.list[index].cashType = v === this.form.list[index].cashType ? "" : v;
        if (this.form.list[index].cashType === "6") {
          const ref = this.$refs[`otherInputs${index}`];
          setTimeout(() => {
            ref[0].focus();
          }, 1);
        }
        if (v !== "6") {
          this.form.list[index].cashTypeOth = "";
        }
      }
    },
    created () {
      // if (localStorage.getItem("pageData")) {
      //   const data = JSON.parse(localStorage.getItem("pageData"));
      //   data.birthTime = data.birthTime ? new Date(data.birthTime) : null;
      //   this.phoneTitle = data.phone.split("-")[0];
      //   data.phone = data.phone.split("-")[1];
      //   this.form = {
      //     ...this.form,
      //     ...data
      //   };
      // }
      this.GetEntryExit();
      window.scrollTo(0, 0);
      if (this.$route.query.index) {
        this.indexs = this.$route.query.index;
        const data = JSON.parse(localStorage.getItem("pageData"))[this.indexs];
        delete data.QRcode;
        // data.list[0].myself = "";
        data.birthTime = data.birthTime ? new Date(data.birthTime) : null;
        this.phoneTitle = data.phone.split("-")[0];
        data.phone = data.phone.split("-")[1];
        data.key = "";
        data.entryExitType = String(data.entryExitType);
        this.form = {
          ...this.form,
          ...data
        };
        this.form.gender = String(this.form.gender);
        // console.log(this.form.list);
      }
      this.getVerification();
      this.getDictionary();
      this.getkey();
      this.getCurrency();
      this.getCountry();
    }
  };
</script>

<style lang="scss" module src="./style.scss">
</style>
<style lang="scss">
.dialog > .el-dialog {
  background: #f9f9ec;
}
.el-radio__input + .el-radio__label {
  color: #000;
}
.el-radio__input.is-checked + .el-radio__label {
  -webkit-print-color-adjust: exact;
  color: #000;
}
.el-radio__inner {
  &::after {
    display: none;
    transition: none;
  }
}
.el-radio__input.is-checked {
  .el-radio__inner {
    border-radius: 0;
    background-color: #43a6df;
    position: relative;
    border: 1px solid #43a6df;
    &::before {
      content: "✓";
      color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}

</style>
